import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneAlt, faCheckCircle, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import ModalOverlay from '../../../components/ui/ModalOverlay/ModalOverlay';
import s from '../CaseFilePage.module.css';

interface AircallModalProps {
  aircallState: 'confirm' | 'calling' | 'success' | 'error';
  aircallError: string;
  clientName: string;
  phoneNumber: string;
  handleConfirmCall: () => void;
  onClose: () => void;
}

export default function AircallModal({
  aircallState,
  aircallError,
  clientName,
  phoneNumber,
  handleConfirmCall,
  onClose,
}: AircallModalProps) {
  const titleMap = {
    confirm: `Call ${clientName}`,
    calling: `Calling ${clientName}…`,
    success: 'Call Initiated',
    error: 'Call Failed',
  };

  return (
    <ModalOverlay onClose={onClose} title={titleMap[aircallState]}>
      <div className={s.aircallBody}>
        {aircallState === 'confirm' && (
          <>
            <div className={s.aircallIcon}>
              <FontAwesomeIcon icon={faPhoneAlt} />
            </div>
            <p>
              Calling: <strong>{phoneNumber}</strong>
            </p>
            <p className={s.aircallHint}>Make sure Aircall is open and status is active.</p>
            <div className={s.modalActions}>
              <button className={s.btnSecondary} onClick={onClose}>
                Cancel
              </button>
              <button className={s.btnPrimary} onClick={handleConfirmCall}>
                <FontAwesomeIcon icon={faPhoneAlt} /> Continue
              </button>
            </div>
          </>
        )}
        {aircallState === 'calling' && (
          <>
            <div className={s.aircallIcon}>
              <FontAwesomeIcon icon={faPhoneAlt} className={s.aircallRinging} />
            </div>
            <p>Initiating call… please wait for the Aircall app.</p>
          </>
        )}
        {aircallState === 'success' && (
          <>
            <div className={s.aircallIconSuccess}>
              <FontAwesomeIcon icon={faCheckCircle} />
            </div>
            <p>Call initiated successfully!</p>
            <p className={s.aircallHint}>Your Aircall app should ring momentarily.</p>
          </>
        )}
        {aircallState === 'error' && (
          <>
            <div className={s.aircallIconError}>
              <FontAwesomeIcon icon={faExclamationCircle} />
            </div>
            <p>Call Failed</p>
            <p className={s.aircallHint}>{aircallError}</p>
            <div className={s.modalActions}>
              <button className={s.btnSecondary} onClick={onClose}>
                Close
              </button>
            </div>
          </>
        )}
      </div>
    </ModalOverlay>
  );
}
